import { Component, ElementRef, Input, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';    
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';             
import { SystemUserService } from '@ascschool/services/user/system-user.service';
import { SystemUser } from '@ascschool/model/user/system-user.model';

@Component({
  selector: 'app-pop-up-nguoi-dung-he-thong',
  templateUrl: './pop-up-nguoi-dung-he-thong.component.html',
  styleUrls: ['./pop-up-nguoi-dung-he-thong.component.scss']
})
export class PopUpNguoiDungHeThongComponent implements OnInit {
  @Input() dataTransmission: any;
  isEditMode = false;
  @ViewChildren("label") labelElement;
  systemUser = new SystemUser();
  errorMsg: string;
  isDisabled = false; 
  passwordChange : any;
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService, 
    public utilsService: UtilsService,
    private service: SystemUserService,
    private fb: FormBuilder,
  ) {
    
  }
  GetById(id: number) { 
    this.service.getSystemUsersById(id).subscribe((res: SystemUser) => {  
      
      this.passwordChange = res.passwordHash;
      this.systemUser = res;
      this.systemUser.confirmPassword = res.passwordHash;
    })
  }
  ngOnInit() {
    if(this.dataTransmission && this.dataTransmission.id > 0){ 
      this.GetById(this.dataTransmission.id);
      this.isEditMode = true;
    } 
  }
 
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  UpdateClose() {  
    if(this.systemUser.passwordHash && this.systemUser.normalizedUserName){ 
      if(this.systemUser.passwordHash == this.systemUser.confirmPassword){ 
        
        if(this.passwordChange != this.systemUser.passwordHash){
          const passwordHash = this.utilsService.md5Encode(this.systemUser.passwordHash);
          const comfirmpasswordHash = this.utilsService.md5Encode(this.systemUser.confirmPassword);
          this.systemUser.passwordHash = passwordHash.toUpperCase();
          this.systemUser.confirmPassword = comfirmpasswordHash.toUpperCase();
          this.service.addOrUpdateSystemUsers(this.systemUser).subscribe((res) => {
            if (res.statusCode == 0) {
              this.utilsService.notifyResponse(res);
              this.close(); 
            }else{
              this.utilsService.notifyResponse(res);
            } 
          })
        }
        // this.service.addOrUpdateSystemUsers(this.systemUser).subscribe((res) => {
        //   if (res.statusCode == 0) {
        //     this.utilsService.notifyResponse(res);
        //     this.close(); 
        //   }else{
        //     this.utilsService.notifyResponse(res);
        //   } 
        // })
      }else{
        this.msg.warning('Xác nhận mật khẩu không đúng');
      }
    }else{
      this.utilsService.notifyValidateNgModel(this.systemUser,this.labelElement);
    } 
  }
 
}
